import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';

export const H1 = styled.h1`
  font-size: 2.125rem;
  line-height: 3rem;
  font-weight: 600;
`;

export const H2 = styled.h2`
  font-size: 1.75rem;
  line-height: 2.4375rem;
  font-weight: 600;
`;

export const H3 = styled.h3`
  font-size: 1.5rem;
  line-height: 2.125rem;
  font-weight: 600;
`;

export const H4 = styled.h4`
  font-size: 1.2rem;
  line-height: 2rem;
  font-weight: 600;
`;

export const Subtitle = styled.p`
  font-size: 1.3125rem;
  line-height: 1.8125rem;
`;

export const Body = styled.p`
  font-size: 1.1875rem;
  line-height: 1.6875rem;
`;

export const P = styled.p`
  font-size: 1.1875rem;
  line-height: 1.875rem;
`;

export const Small = styled.p`
  font-size: 1.0625rem;
  line-height: 1.5rem;
`;

export const Caption = styled.span`
  font-size: 0.9375rem;
  line-height: 1.3125rem;
`;

export const Overline = styled.span`
  font-size: 0.9375rem;
  line-height: 1.3125rem;
  letter-spacing: 10%;
  text-transform: uppercase;
`;

export const CircledNumber = styled(Caption)`
  background-color: ${({ theme }) => theme.colors.navyGreenLight};
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  border-radius: 50%;
  padding: 0.2rem 0.5rem;
  font-weight: 600;
  font-size: 0.9375rem;
  font-variant-numeric: tabular-nums;
`;

export const LegendText = styled(Body)`
  font-size: 1rem;
  font-weight: 600;
`;

/* **************************************************************** */
/* *************************** SECTION **************************** */
/* **************************************************************** */

export const PageTitle = styled(H2)`
  font-weight: 700;
  text-transform: capitalize;
`;

export const SectionTitle = styled(H3)`
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 1rem;
`;
